import React, { memo } from "react";
import "./styles.scss";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const RecentAttendedLectures = ({ classroomId = "" }) => {
  const navigate = useNavigate();

  const getStartedHandler = () => {
    navigate(`/student/myClassrooms/${classroomId}/liveclasses`);
  };
  return (
    <div
      style={{
        height: "100%",
        textAlign: "center",
        alignContent: "center",
        gap: "10px",
        display: "grid",
      }}
    >
      <div style={{ fontSize: "14px", fontWeight: 600, color: "#1D2026" }}>
        No recent activity
      </div>
      <div>
        <Button
          onClick={getStartedHandler}
          className="start-classroom-styles"
          variant="outline-primary"
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default memo(RecentAttendedLectures);
